import React from 'react'

type Props = {
  className?: string
  fill?: string
  size?: string
}

const Search = ({ className, fill, size }: Props) => (
  <svg
    className={className}
    fill={fill}
    height={size ?? 24}
    viewBox='0 0 24 24'
    width={size ?? 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16.1613 14.1184C17.2182 12.651 17.8388 10.8536 17.8388 8.91938C17.8388 3.99314 13.8456 0 8.91938 0C3.99314 0 0 3.99314 0 8.91938C0 13.8456 3.99314 17.8388 8.91938 17.8388C10.8531 17.8388 12.6501 17.2185 14.1172 16.1621L20.9331 22.9778C21.4977 23.5423 22.4131 23.5423 22.9776 22.9778C23.5423 22.4131 23.5422 21.4977 22.9775 20.9331L16.1613 14.1184ZM8.91938 15.0943C5.50257 15.0943 2.74443 12.3362 2.74443 8.91938C2.74443 5.50257 5.50257 2.74443 8.91938 2.74443C12.3362 2.74443 15.0943 5.50257 15.0943 8.91938C15.0943 12.3362 12.3362 15.0943 8.91938 15.0943Z' />
  </svg>
)

export default Search
